import { Link } from 'react-router-dom';
import { FeedbackMessage } from '../FeedbackMessage';
import { ConfirmPasswordField, PasswordRequirementsField, SubmitButton } from '../fields';
import type { AuthTemplateProps } from '../types';

export default function ResetPasswordTemplate(props: AuthTemplateProps) {
    return (
        <section className="mx-auto max-w-lg space-y-4">
            <div className="p-8 bg-coconut rounded-lg space-y-5">
                <h1 className="text-2xl font-semibold">Choose a new password</h1>
                <p className="text-base text-licorice">
                    Set a strong password for your Insureworks account.
                </p>

                <FeedbackMessage feedback={props.message} />
                <FeedbackMessage feedback={props.error} tone="error" />

                <form className="space-y-4" onSubmit={props.onSubmit} noValidate>
                    <PasswordRequirementsField
                        {...props}
                        requirements={props.requirements}
                        label="New password"
                    />
                    <ConfirmPasswordField {...props} />
                    <SubmitButton label="Reset password" loading={props.loading} />
                </form>
            </div>

            <div className="mt-4 text-sm text-licorice">
                <span className="inline-block mr-0.5">Already have an account?</span>
                <Link
                    className="text-sm font-semibold underline decoration-dotted hover:no-underline"
                    to={props.authHref('login')}
                >
                    Log in
                </Link>
            </div>
        </section>
    );
}
